import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  increment as firestoreIncrement,
  serverTimestamp,
  query,
  where,
  getDoc,
  getDocs,
} from 'firebase/firestore';
import { db } from './firebaseClient';

const COLLECTION_NAME = 'pantry_items';

/**
 * Add a new pantry item
 */
export const addPantryItem = async (itemData) => {
  const docRef = await addDoc(collection(db, COLLECTION_NAME), {
    ...itemData,
    quantity: itemData.quantity || 0,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return { id: docRef.id, ...itemData };
};

/**
 * Update an existing pantry item
 */
export const updatePantryItem = async (itemId, updateData) => {
  const itemRef = doc(db, COLLECTION_NAME, itemId);
  await updateDoc(itemRef, {
    ...updateData,
    updatedAt: serverTimestamp(),
  });
  return { id: itemId, ...updateData };
};

/**
 * Delete a pantry item
 */
export const deletePantryItem = async (itemId) => {
  await deleteDoc(doc(db, COLLECTION_NAME, itemId));
  return { success: true, id: itemId };
};

/**
 * Increment pantry item quantity
 */
export const incrementPantryQuantity = async (itemId, amount = 1) => {
  const itemRef = doc(db, COLLECTION_NAME, itemId);
  await updateDoc(itemRef, {
    quantity: firestoreIncrement(amount),
    updatedAt: serverTimestamp(),
  });
  return { success: true, id: itemId };
};

/**
 * Find or create a pantry item by name
 * Used when adding items from shopping list
 */
export const findOrCreatePantryItem = async (itemName, itemData = {}) => {
  // Search for existing item by name (case sensitive exact match)
  const itemsQuery = query(
    collection(db, COLLECTION_NAME),
    where('name', '==', itemName)
  );
  
  const snapshot = await getDocs(itemsQuery);
  
  if (!snapshot.empty) {
    // Found existing item, return it
    const existingItem = snapshot.docs[0];
    return { id: existingItem.id, ...existingItem.data() };
  }
  
  // Create new item if not found
  return addPantryItem({
    name: itemName,
    quantity: itemData.quantity || 0,
    unit: itemData.unit || '',
    category: itemData.category || '',
    location: itemData.location || 'pantry',
    price: itemData.price || 0,
    ...itemData,
  });
};

/**
 * Get a single pantry item by ID
 */
export const getPantryItem = async (itemId) => {
  const itemRef = doc(db, COLLECTION_NAME, itemId);
  const itemSnap = await getDoc(itemRef);
  if (itemSnap.exists()) {
    return { id: itemSnap.id, ...itemSnap.data() };
  }
  return null;
};

